import React from 'react';
import { FaLayerGroup, FaDownload } from 'react-icons/fa';
import { useDownloadMap } from '../utils/useDownloadMap';

// Mobile-only bottom bar: keeps Layers and Download Map within thumb reach
// instead of tucked into corner panels. Zoom stays with Leaflet's own
// bottom-right control (shifted up above this bar via CSS).
export default function MobileActionBar({ layersOpen, onToggleLayers, selected }) {
  const { downloading, download } = useDownloadMap(selected);

  return (
    <div className="mobile-action-bar">
      <button
        className={`mab-btn${layersOpen ? ' active' : ''}`}
        onClick={onToggleLayers}
      >
        <FaLayerGroup size={18} />
        <span>Layers</span>
      </button>

      <button
        className="mab-btn mab-btn--primary"
        onClick={download}
        disabled={!selected || downloading}
      >
        <FaDownload size={18} />
        <span>{downloading ? 'Downloading…' : 'Download'}</span>
      </button>
    </div>
  );
}
